// @flow
import {
  GROUP_CLASS_STATUS_ARCHIVED_COMPLIANT,
  GROUP_CLASS_STATUS_ARCHIVED_DEFAULT_PAYMENT,
  GROUP_CLASS_STATUS_ARCHIVED_NOT_COMPLETED,
  GROUP_CLASS_STATUS_ARCHIVED_TO_REMOVE,
} from '@app/constants/constants';

class GroupClassStatusHelpers {
  /**
   * ARCHIVED_GROUP_CLASS_STATUSES
   * @return {string[]}
   */
  static get ARCHIVED_GROUP_CLASS_STATUSES(): string[] {
    return [
      GROUP_CLASS_STATUS_ARCHIVED_DEFAULT_PAYMENT,
      GROUP_CLASS_STATUS_ARCHIVED_NOT_COMPLETED,
      GROUP_CLASS_STATUS_ARCHIVED_COMPLIANT,
      GROUP_CLASS_STATUS_ARCHIVED_TO_REMOVE,
    ];
  }

  /**
   * isGroupClassArchived
   * @param {?string} status
   * @return {boolean}
   */
  static isGroupClassArchived(status: ?string): boolean {
    return GroupClassStatusHelpers.ARCHIVED_GROUP_CLASS_STATUSES.includes(status);
  }

  /**
   * canEditGroupClass
   * Archived group classes are editable by admins only.
   * @param {?string} status
   * @param {boolean} isAdmin
   * @return {boolean}
   */
  static canEditGroupClass(status: ?string, isAdmin: boolean): boolean {
    return !GroupClassStatusHelpers.isGroupClassArchived(status) || isAdmin;
  }
}

export default GroupClassStatusHelpers;
